import { TradingFormState } from '@client/widgets/trading-form/trading-form.types';

type SanitizerOptions = {
  stripFiles?: boolean;
};

export const sanitizeTradingFormState = (
  state: TradingFormState,
  options?: SanitizerOptions
): TradingFormState => {
  const stripFiles = options?.stripFiles ?? true;
  if (!stripFiles) {
    return state;
  }

  const hasMarketFile = state.marketConfig?.file != null;
  const hasTimeframeFiles =
    state.timeframes?.some((timeframe) => timeframe.file != null) ?? false;

  if (!hasMarketFile && !hasTimeframeFiles) {
    return state;
  }

  const marketConfig = state.marketConfig
    ? {
        ...state.marketConfig,
        file: undefined
      }
    : undefined;

  const timeframes = state.timeframes?.map((timeframe) => ({
    ...timeframe,
    file: undefined
  }));

  return {
    ...state,
    marketConfig,
    timeframes
  };
};
